/*
 * @Author       : yiyang
 * @Date         : 2020-09-03 11:02:09
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-11-12 18:17:11
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/layouts/GraphicLayout/index.js
 * @URL          : 
 */
import './index.css'
import React, { useEffect } from 'react'
// import NETImage from 'components/net-image'

/**
 * 首页布局
 */
export default function Graphiclayout(props) {
    let { children, pageTitle } = props;
    useEffect(() => {
        document.title = pageTitle || '上海博物馆';
    })

    return (
        <section className='graphic__layout'>
            {/* <NETImage
                src='banner-v2.jpeg'
                useAutoHeight
                startHeight={120}
            /> */}
            <div className='graphic__layout-content--wrapper'>
                <div className='graphic__layout-content'>
                    {children}
                </div>
            </div>
            {/* <div className='graphic__layout-bottom'>
                <span>上海博物馆</span>
            </div> */}
        </section>
    )
}